import styled from "styled-components";
import { Card } from "react-bootstrap";
import { Button } from "components/Button/index";

export const StrategyDetailsContainer = styled.div`
  margin: 0em auto 5em auto;
  position: relative;
  // border: 1px solid red;

  .divider-line {
    border: 1px solid ${({ theme }) => theme.divider.bg.tertiary};
    border-radius: 16px;
    gap: 0.5rem;
  }

  &.mobile-transparent-divider {
    border: 1px solid transparent;
    border-radius: 16px;
    gap: 0.5rem;

    &.invest-main-container {
      height: 100%;
    }
  }

  .transparent-divider {
    border: 1px solid transparent;
    border-radius: 16px;
    gap: 0.5rem;

    &.invest-main-container {
      height: 100%;
      display: block;
    }
  }

  .sticky-card {
    .card {
      background: ${({ theme }) => theme.card.bg.secondary};
      border: 1px solid ${({ theme }) => theme.card.border.quaternary};
    }
  }

  .divider {
    border-color: ${({ theme }) => theme.divider.bg.tertiary};
  }

  .description-content {
    .btn-read-more {
      position: absolute;
      bottom: 17px;
      right: 20px;

      &.btn-dark-read-more {
        width: 130px;
        border-radius: 25px;
        bottom: 10px;
      }

      .dot-fillers {
        position: absolute;
        bottom: 0px;
        color: ${({ theme }) => theme.card.font.secondary};
      }

      button {
        background: ${({ theme }) => theme.menu.card.bg};
        color: #048af5;
        padding: 0px 4px 0px 26px;
        height: auto;

        &.dark-btn {
          background-color: #121e32;
          padding: 4px;
          width: 100%;
        }
      }

      svg {
        path {
          stroke: #048af5;
        }
      }
    }
  }

  .asset-allocation,
  .trade-performance,
  .asset-trading-volume,
  .asset-trading-volume-chart,
  .drawdown,
  .historical-allocation,
  .calendar-returns,
  .description-wrapper {
    h2 {
      color: ${({ theme }) => theme.card.font.tertiary};
      font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_500};
      font-size: ${({ theme }) => theme.constants.FONT_SIZE_18};
    }
  }

  .historical-performance {
    margin-top: 15px;

    h2 {
      color: ${({ theme }) => theme.card.font.tertiary};
      font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_500};
      font-size: ${({ theme }) => theme.constants.FONT_SIZE_18};
      padding-bottom: 10px;
    }
  }

  .hero-wrapper {
    padding-top: 0px;

    .hero-tab-container
      .dashboard-row
      .name-wrapper
      .details
      .details__heading_wrapper {
      h2 {
        color: ${({ theme }) => theme.card.font.tertiary};
        font-size: 32px;
        font-weight: 500;
        margin-bottom: 5px;
      }

      span {
        color: ${({ theme }) => theme.tab.color.quinary};
        font-size: 14px;
        font-weight: 400;
      }

      .title .placeholder-glow {
        width: 200px;
      }
    }

    .tabs-wrapper {
      padding-left: 15px;

      .tabs {
        gap: 16px;

        .btn-filter {
          padding: 10px 0px;
          &:first-child {
            padding-left: 0px;
          }
        }
      }
    }
  }

  .recommend-card-col {
    .card {
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      background-color: transparent;

      h2 {
        font-size: 32px;
      }

      p {
        font-size: 17px;
      }

      .btn-find {
        position: relative;
        bottom: 0;
      }
    }
  }

  .description-wrapper {
    margin: 1rem 0;

    h2 {
      width: fit-content;
      margin-right: 12px;
    }

    p {
      color: ${({ theme }) => theme.tab.color.quinary};
      font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_400};
      font-size: ${({ theme }) => theme.constants.FONT_SIZE_14};
      line-height: 20px;
    }
  }

  .key-metrics-wrapper {
    padding: 20px 0px;
    border-radius: 12px;
    border: 1px solid #e9eaeb;
    background: #fff;
    margin-bottom: 15px;

    .title-wraper {
      padding: 0px 24px 21px;
      display: flex;
      align-items: center;
      justify-content: space-betweeen;
      border-bottom: 1px solid #e9eaeb;

      h2 {
        color: #181d27;
        font-family: "Geist", sans-serif;
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 0px;
      }

      .view-more {
        width: 80px;
        padding: 0px 0px;
        border: none;
        background: none;
        color: #535862;
        font-family: "Geist", sans-serif;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  .asset-trading-volume,
  .trade-performance,
  .calendar-returns,
  .trades-wrapper,
  .logs-wrapper {
    margin: 1rem 0;
    height: calc(100% - 20px);

    h2 {
      font-size: 18px;
      font-weight: 500;
      color: ${({ theme }) => theme.card.font.tertiary};
    }
  }

  .asset-allocation,
  .historical-allocation {
    min-height: 200px;
    margin-top: 1rem;

    .current-alloc-mobile {
      max-height: 300px;
      overflow: auto;

      .recharts-legend-wrapper {
        top: 200px !important;
      }
    }

    .mobile-top-holdings {
      display: none;
    }
  }

  .historical-allocation .pie-chart .pie-label {
    font-size: 14px;
    font-weight: 500;
    fill: ${({ theme }) => theme.global.color.bodyColor};
  }

  .asset-trading-volume-chart {
    .chart-container {
      min-height: 280px;
      height: 100%;

      .treemap-custom-tooltip {
        max-width: 300px;
        text-align: start;
        background: ${({ theme }) => theme.chart.tooltip.primary};
        border-radius: 10px;
        color: ${({ theme }) => theme.chart.tooltip.tertiary};
        padding: 5px 10px;

        p {
          font-weight: 400;
          font-size: 11px;
          margin-bottom: 0;
        }
      }
    }
  }

  .pie-chart-wrapper {
    height: 250px;

    .recharts-legend-wrapper {
      ul {
        display: flex;
        flex-direction: column;

        li {
          color: ${({ theme }) => theme.card.font.tertiary};
          width: 70px;
        }
      }
    }
  }

  .supported-brokers {
    padding: 0;
    border: 0px;

    .icon-wrapper {
      display: flex;
      padding-bottom: 10px;
      flex-wrap: wrap;
      max-height: 250px;
      overflow: auto;

      img {
        height: 50px;
        width: 50px;
        border-radius: 50%;
      }
    }
  }

  .community {
    height: 100%;

    p {
      font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_400};
      font-size: ${({ theme }) => theme.constants.FONT_SIZE_12};
      color: ${({ theme }) => theme.global.caption.font.color};
      margin-bottom: 0;
    }

    .img-wrapper {
      position: relative;
      img {
        height: 51px;
        width: 51px;

        &.override {
          margin-left: -10px;
        }

        &.last {
          filter: brightness(0.2);
        }
      }

      .count {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        margin-left: -5px;
        font-weight: 600;
        font-size: 14px;
        color: ${({ theme }) => theme.global.extraInfo.font.color};
      }
    }
  }

  .aggression-level {
    .title {
      font-size: 18px;
    }

    .sub-title {
      font-weight: 500;
      font-size: 15px;
    }

    .line-wrapper {
      display: flex;
      margin: 12px -3px;

      .line {
        width: 100%;
        height: 10px;
        background: linear-gradient(
          90deg,
          rgb(2 178 82) 20%,
          rgb(255 178 32) 50%,
          rgb(255 24 24) 100%
        );
      }
    }

    .label-wrapper {
      display: flex;
      justify-content: space-between;

      .label,
      .arrow {
        text-align: center;
        width: 90px;
        margin: 0 2px;
      }

      .label {
        font-size: 10px;
        font-weight: 500;
        color: ${({ theme }) => theme.card.font.tertiary};

        &:first-child {
          text-align: left;
        }
        &:last-child {
          text-align: right;
        }
      }

      .arrow {
        display: flex;
        justify-content: start;
        width: 100%;
      }

      .arrow-up {
        height: 10px;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 7px solid ${({ theme }) => theme.global.color.arrow};
        margin-top: -15px;
        margin-bottom: 5px;
        margin-left: -10px;
      }
    }

    .description {
      font-size: 14px;
      color: ${({ theme }) => theme.global.text.tertiary};
    }
  }

  .license-strategy {
    height: 100%;
    margin-top: 1rem;
    justify-content: space-between;

    button {
      height: 40px;
      padding: 0;
    }
  }

  .trades-table {
    tr th {
      text-align: left;
    }
    tbody {
      .no-data-text {
        color: #30528a;
        font-weight: 600;
        font-size: 14px;
      }
      .table-cell {
        cursor: pointer;
        .asset-item-left {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          .asset-img {
            width: 29px;
            height: 29px;
            margin: 0 6px;

            img {
              width: 29px;
              height: 29px;
            }
          }

          .asset-wrapper {
            margin-left: 10px;

            .asset-title {
              font-weight: 600;
              font-size: 14px;
              width: 100px;
              color: ${({ theme }) => theme.global.color.bodyColor};
            }

            .asset-description {
              font-size: 14px;
              font-weight: 400;
              color: ${({ theme }) => theme.global.color.bodyColor};
            }
          }
        }
      }
    }
  }

  .blur-overlay {
    position: relative;
    filter: blur(4px);
    -o-filter: blur(4px);
    -ms-filter: blur(4px);
    -moz-filter: blur(4px);
    -webkit-filter: blur(4px);
  }

  @media screen and (max-width: 767px) {
    .hero-wrapper {
      .hero-tab-container
        .dashboard-row
        .name-wrapper
        .details
        .details__heading_wrapper
        h2 {
        font-size: 22px;
      }
      .tabs-wrapper {
        .tabs {
          .btn-filter {
            font-size: 13px;
            &:first-child {
              padding-left: 0px;
            }
          }
        }
      }
    }

    .description-content .btn-read-more {
      bottom: 13px;
      right: 15px;
    }

    .supported-brokers {
      padding: 16px;
      border: 1px solid ${({ theme }) => theme.card.border.quaternary};
      border-radius: 10px;
    }

    .aggression-level {
      background: ${({ theme }) => theme.card.bg.secondary};
      border: 1px solid ${({ theme }) => theme.card.border.quaternary};
      padding: 16px !important;
      border-radius: 16px;
    }

    .no-data {
      margin-bottom: 3rem;
    }
  }

  @media (min-width: 1700px) {
    .btn-back-secondary-page {
      position: absolute;
      left: 16px;
      top: 38px;
      margin-bottom: 0;
    }
  }

  @media only screen and (min-width: 767px) and (max-width: 999px) {
    .license-strategy,
    .aggression-level {
      margin-top: 0;
    }
  }

  @media (max-width: 820px) {
    .historical-allocation {
      .desktop-top-holdings {
        display: none;
      }

      .mobile-top-holdings {
        display: block;

        .pie-chart-wrapper {
          height: 500px;
        }
      }
    }
  }

  @media (max-width: 767px) {
    margin: 1em auto;

    .historical-performance {
      .investment-value {
        position: relative;
        top: 0;
        left: 0;
      }

      h2 {
        font-size: 18px;
      }

      p {
        font-size: 14px;
      }

      .chart-wrapper {
        height: 350px !important;
      }

      .recharts-surface,
      .h-performance-filter {
        margin-top: 1rem;
      }
    }

    .aggression-level .label-wrapper {
      .label,
      .arrow {
        width: 120px;
      }
    }

    .description-wrapper {
      margin-top: 0;
    }

    .pie-chart-wrapper {
      height: 350px;
    }

    .trades-table .table-container {
      overflow: auto;
    }

    .mobile-view .accordion {
      border-radius: 10px;
      background: ${({ theme }) => theme.card.bg.secondary};
      border: 1px solid ${({ theme }) => theme.card.border.quaternary};
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      margin-bottom: 1rem;

      .accordion-item {
        background-color: ${({ theme }) => theme.accordion.bg.primary};
        margin: 0px;

        .accordion-header .accordion-button {
          background-color: ${({ theme }) => theme.accordion.bg.primary};
          padding: 12px;
          height: 100%;
          color: ${({ theme }) => theme.card.font.tertiary};
          font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_500};
          font-size: ${({ theme }) => theme.constants.FONT_SIZE_18};

          &:after {
            background-size: 24px;
          }
        }
        .accordion-body {
          background-color: ${({ theme }) => theme.accordion.bg.primary};
          padding: 0;
        }
      }

      .accordion-item:last-of-type > .accordion-collapse {
        padding: 10px;
      }
    }
    .mobile-transparent-divider.invest-main-container {
      height: auto;
      width: 100%;
      margin: 0px;
    }

    .fixed-bottom-row {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 1000;
      background-color: ${({ theme }) => theme.card.bg.secondary};
      border-radius: 25px;
      box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
      padding: 0px;
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
      margin: 0px;

      .sticky-card .card {
        border: 0px;
        padding: 10px;

        .heading-wrapper .btn-bg-color {
          background-color: ${({ theme }) => theme.global.bg.primary};
        }
      }
    }
  }

  @media screen and (max-width: 400px) and (min-width: 380px) {
    .hero-wrapper {
      .tabs-wrapper {
        .tabs {
          gap: 10px;
        }
      }
    }
  }
`;

export const NoBacktestContainer = styled.div`
  display: flex;
  padding: 32px 0;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  border: 1px solid #e9eaeb;
  background: linear-gradient(180deg, #fdfdfd 0%, #f5f5f5 100%);
  margin-top: 24px;

  h2 {
    font-size: 16px;
    font-family: "Public Sans", sans-serif;
    color: #414651;
    font-weight: 600;
    margin: 16px 0px 4px;
  }

  p {
    max-width: 400px;
    color: #535862;
    text-align: center;
    font-family: "Public Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 0px;
  }
`;

export const DetailsHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  .heading-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
    max-width: 100%;

    h2 {
      margin-bottom: 0;
    }

    .action-wrapper {
      display: flex;
      gap: 10px;
      align-items: center;
      flex-wrap: nowrap;
      justify-content: space-between;

      .wt-btn-invest {
        width: 60%;
      }

      .btn-invest {
        width: 100%;
        flex-grow: 1;
      }

      .disable-btn {
        background-color: ${({ theme }) => theme.button.bg.disabled} !important;
        color: ${({ theme }) => theme.card.color.primary} !important;

        svg {
          path {
            stroke: rgb(156, 156, 171);
          }
        }
      }

      .btn-edit {
        padding: 6px;
        width: 36px;
        height: 36px;
      }
    }

    .icon-button {
      border-radius: 50%;
      background-color: #048af5;
      height: 37px;
      width: 37px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      svg {
        path {
          stroke: #fff;
        }
      }

      &.disabled {
        cursor: not-allowed;
      }
    }
  }

  .placeholder-glow {
    flex: 1;
  }

  @media (max-width: 767px) {
    .heading-wrapper {
      h2 {
        font-size: 18px;
      }
      .sub-header {
        width: 100%;
      }
      .action-wrapper {
        width: 100%;
        flex-direction: row-reverse;
        justify-content: center;
        gap: 16px;
      }
    }
  }

  @media screen and (max-width: 1366px) and (min-width: 768px) {
    .heading-wrapper .action-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;

      .wt-btn-invest {
        width: 75%;
      }
    }
  }

  @media screen and (max-width: 1400px) and (min-width: 768px) {
    .heading-wrapper .action-wrapper .wt-btn-invest {
      .btn-invest {
        width: 100%;
      }
    }
  }
`;

export const CardContainer = styled(Card)`
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e9eaeb;
  background: #fff;
  margin-bottom: 15px;

  &.secondary {
    .title {
      color: ${({ theme }) => theme.heading.color.primray};
      font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_500};
      font-size: ${({ theme }) => theme.constants.FONT_SIZE_18};
    }
  }

  &.backtest-logs {
    white-space: pre-wrap;
    max-height: 500px;
    overflow-y: scroll;

    p {
      font-size: 14px;
      color: ${({ theme }) => theme.card.font.tertiary};
    }
  }

  &.historical-performance {
    padding-right: 20px;
  }
`;

export const AuthorDetailsContainer = styled.div`
  h2 {
    font-size: 18px;
  }

  .author-name {
    display: flex;
    color: ${({ theme }) => theme.heading.color.secondary};
    font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_600};
    font-size: ${({ theme }) => theme.constants.FONT_SIZE_18};
    margin-bottom: 0;
    .name {
      width: 180px;
    }
  }

  .avatar {
    margin-right: 15px;

    img {
      width: 48px;
      height: 48px;
    }
  }

  .author-highlight {
    font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_400};
    font-size: ${({ theme }) => theme.constants.FONT_SIZE_14};
    color: ${({ theme }) => theme.global.color.bodyColor};

    a {
      color: ${({ theme }) => theme.global.extraInfo.font.color};
    }
  }

  @media (max-width: 767px) {
    .author-name {
      margin-bottom: 0;

      .name {
        font-size: 14px;
      }
    }

    .author-highlight {
      font-size: 12px;
    }
  }
`;

export const KeyStatsContainer = styled.div`
  .modal-ul {
    padding: 0;
    margin: 0;
    padding-bottom: 0;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 20px;
    list-style: none;
  }

  ul {
    padding: 0;
    margin: 20px 20px 0px;
    padding-bottom: 0;
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 20px;
    list-style: none;
    text-align: left;
    flex-wrap: wrap;

    li.button-wrapper {
      display: flex;
      align-items: center;
    }

    li {
      justify-content: space-between;
      // padding-bottom: 20px;
      text-align: left;

      .label-wrapper {
        gap: 10px;

        span.key {
          font-weight: 400;
          font-size: 14px;
          text-transform: capitalize;
          color: ${({ theme }) => theme.global.extraInfo.font.color};
          width: 100%;
          display: flex;
          gap: 5px;

          span.label {
            color: #717680;
            font-family: "Geist", sans-serif;
            font-size: 12px;
            font-weight: 400;
            line-height: 18px;
            text-wrap: wrap;
          }
        }
      }

      span.stats {
        color: #414651;
        font-size: 16px;
        font-family: "Geist", sans-serif;
        font-weight: 500;
        line-height: 24px;
        text-align: right;
        text-transform: capitalize;
      }
    }
  }

  @media screen and (max-width: 500px) {
    ul {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media screen and (max-width: 767px) and (min-width: 500px) {
    ul {
      grid-template-columns: repeat(3, 1fr);
      columns: 1;
      -webkit-columns: 1;
      -moz-columns: 1;
    }
  }

  @media screen and (max-width: 767px) {
    ul li span.stats {
      width: 100%;
      display: flex;
      text-align: left;
      justify-content: flex-start;
    }
  }

  @media screen and (max-width: 1300px) {
    ul {
      grid-template-columns: repeat(6, 1fr);
    }
  }

  @media screen and (max-width: 1024px) {
    ul {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  @media screen and (max-width: 640px) {
    ul {
      grid-template-columns: repeat(3, 1fr);
    }
  }
`;

export const NoDataMessage = styled.div`
  height: 425px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  font-size: 16px;
`;

export const BacktestFilterContainer = styled.div`
  width: 100%;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #fafafa;
  display: flex;
  padding: 20px;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 24px;
  box-shadow: 0 2px 2px 0 rgba(255, 255, 255, 0.35) inset,
    0 0 0 1px rgba(10, 13, 18, 0.18) inset,
    0 -2px 0 0 rgba(10, 13, 18, 0.05) inset, 0 1px 10px 0 rgba(10, 13, 18, 0.05);

  .form {
    display: flex;
    gap: 10px;
    align-items: flex-end;
    // justify-content: space-between;
    flex-wrap: wrap;

    .FormGroup {
      flex: 1 1 200px;
      max-width: 300px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }

    .calendar-group {
      flex: 2 1 auto;
      min-width: 250px;
      display: flex;
      flex-direction: column;
    }

    .form-label {
      font-size: 14px;
      font-weight: 500;
      font-family: "Geist", sans-serif;
      color: #414651;
      margin-bottom: 6px;
    }

    .form-control {
      width: 100%;
      font-size: 16px;
      font-weight: 400;
      font-family: "Geist", sans-serif;
      color: #181d27;
      border: 1px solid #d5d7da !important;
      padding: 8px 12px;
      border-radius: 8px;
      border: 1px solid red;
      background: #fff;
      box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);
      margin-bottom: 0px;
    }

    .backtest-btn {
      width: 145px;
      height: 42px;
      font-size: 14px;
    }
  }

  .loader-scenario {
    margin: 20px;
    width: calc(100% - 40px);
  }

  .action-wrapper {
    display: flex;
    gap: 10px;
  }

  @media (max-width: 767px) {
    border: 0px;
  }
  .tooltip-help {
    margin-left: 4px;
    cursor: help;
  }
`;

export const SceneriosCardContainer = styled.div`
  padding: 6px 0px;
  cursor: pointer;
  overflow: hidden;
  background: none;
  border: none !important;

  &:hover {
    h4 {
      transform: scale(1);
      color: #1841dd;
      font-weight: 500;
    }
  }

  &.active-card {
    h4 {
      color: #1841dd;
    }
  }

  h4 {
    font-size: 14px;
    color: #535862;
    font-family: Geist, -apple-system, BlinkMacSystemFont, "Segoe UI",
      sans-serif;
    font-weight: 400;
    line-height: 20px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-radius: 6px;
    transition: all 0.2s ease;
    margin-bottom: 0px;
  }
`;

export const SectorAllocationContainer = styled.div`
  .header {
    display: flex;
    h2 {
      margin-bottom: 0;
      align-self: self-end;
    }
    button {
      padding: 2px 20px;
      &:last-child {
        margin-left: 8px;
      }
    }
  }
  .line-wrapper {
    display: flex;
    margin: 12px -3px;

    .line {
      width: 100%;
      height: 10px;

      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }

      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }

  .list-wrapper {
    margin-bottom: 8px;
    font-size: 14px;

    .label {
      text-transform: uppercase;
      display: flex;
      align-items: center;

      .dot-wrapper {
        display: flex;
        align-items: center;
        margin-bottom: 2px;

        .dot {
          width: 15px;
          height: 6px;
          background-color: #cecece;
          border-radius: 10px;
          margin-right: 6px;
        }
      }

      .dot-label {
        color: ${({ theme }) => theme.global.text.tertiary};
      }
    }
    .value {
      text-align: end;
      color: ${({ theme }) => theme.global.text.tertiary};
    }
  }
`;

export const HistoricalHoldingsContainer = styled.div`
  .description {
    display: flex;
    justify-content: space-between;
    font-size: 16px;

    .date-filter {
      display: flex;
      align-items: center;

      .date-select {
        margin-left: 12px;
      }
    }
  }

  ul {
    columns: 2;
    -webkit-columns: 2;
    -moz-columns: 2;
    padding: 0;
    margin: 0;
    padding-bottom: 0.7em;

    li {
      display: flex;
      justify-content: space-between;
      margin-bottom: 6.5px;
      font-size: 16px;
    }
  }
`;

export const LockContentBox = styled.div`
  position: fixed;
  top: 35%;
  left: 50%;
  background: ${({ theme }) => theme.modal.bg.tertiary};
  transform: translate(-50%, 0);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  padding: 2rem 4rem;
  width: 100%;
  max-width: 440px;
  text-align: center;
  border-radius: 10px;
  display: ${(props) => (props.visible ? "block" : "none")};

  .upgrade-btn {
    width: 100%;
    border-radius: 25px;
  }

  h2 {
    font-weight: 600;
    font-size: 20px;
    margin: 20px 0;
  }

  p {
    font-size: 15px;
  }
`;

export const AnnualReturnsContainer = styled.div`
  .header {
    display: flex;
    h2 {
      margin-bottom: 0;
      align-self: self-end;
    }
    button {
      padding: 2px 20px;
      &:last-child {
        margin-left: 8px;
      }
    }
  }
`;

export const DescriptionContainer = styled.div`
  position: relative;
  max-height: ${(props) => (props.isExpanded ? "none" : "140px")};
  overflow: hidden;
  transition: max-height 0.3s ease;

  &.description-collapsed {
    max-height: 80px;
    overflow: hidden;
  }

  &.description-expanded {
    max-height: none;
    overflow: visible;
  }
`;

export const ReadMoreButton = styled(Button)`
  background: transparent;
  border: none;
  cursor: pointer;
`;
